
/**
 * SEO 配置 - models (Italiano)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Generatore video IA di punta | WeryAI',
        description: 'Google Veo 3.1: Modello video IA di punta con audio nativo e controllo frame.',
        keywords: 'Google Veo 3.1, video IA, generatore video, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - Generazione video IA di alta qualità | WeryAI',
        description: 'Prova Veo 3 su WeryAI. Risultati di alta qualità.',
        keywords: 'Veo 3, Google Veo, video IA, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast Generazione video IA ultraveloce | WeryAI',
        description: 'Prova Veo 3 Fast su WeryAI. Risultati veloci e di alta qualità.',
        keywords: 'Veo 3 Fast, video IA veloce, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Generatore video IA realistico | WeryAI',
        description: 'Prova Sora 2 su WeryAI. Risultati di alta qualità.',
        keywords: 'Sora 2, OpenAI Sora, video IA, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Generatore video IA | WeryAI',
        description: 'Prova WeryAI Video 1.0 per creare video IA cinematografici.',
        keywords: 'WeryAI Video 1.0, video IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Generatore Immagini IA Nativo | WeryAI',
        description: 'Usa WeryAI Image 2 per generazione nativa sorprendente di immagini IA! Modello di punta con controllo stile avanzato. Crediti gratis, nessuna carta.',
        keywords: 'WeryAI Image 2, generatore immagini IA nativo, immagine IA di punta, qualità studio IA, WeryAI Image gratis, come usare WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - Generatore Immagini xAI | WeryAI',
        description: 'Usa Grok 2 su WeryAI per generare immagini IA creative! Modello xAI con flessibilità artistica e stili visivi unici. Crediti gratis, nessuna carta.',
        keywords: 'Grok 2, Grok AI, generatore immagini xAI, arte IA, immagini IA creative, Grok 2 gratis, come usare Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Generatore di Immagini | WeryAI',
        description: 'Nano Banana 2 alimentato da Gemini con conoscenza mondiale e ricerca in tempo reale. Genera immagini accurate e straordinarie a velocità ultra-rapida.',
        keywords: 'Nano Banana 2, Google AI, Gemini, generazione immagini, rendering testo, coerenza multi-soggetto, 4K, WeryAI',
        og_title: 'Generatore di immagini Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 è alimentato da Gemini con comprensione profonda del mondo e ricerca in tempo reale, generando immagini belle e fattualmente accurate.',
        twitter_title: 'Generatore di immagini Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 è alimentato da Gemini con comprensione profonda del mondo e ricerca in tempo reale, generando immagini belle e fattualmente accurate.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Generatore di immagini AI Nano Banana 2',
        twitterImageAlt: 'Generatore di immagini AI Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling AI - Generatore video IA cinematografico | WeryAI',
        description: 'Prova Kling AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Kling AI, video IA, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Generatore e editor video IA | WeryAI',
        description: 'Prova Runway AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Runway AI, video IA, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Generatore video IA | WeryAI',
        description: 'Prova Hailuo 2.3 su WeryAI. Risultati di alta qualità.',
        keywords: 'Hailuo 2.3, video IA, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Generatore video IA avanzato | WeryAI',
        description: 'Prova Hailuo AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Hailuo AI, video IA, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Generatore animazione IA | WeryAI',
        description: 'Prova Pika 2.2 su WeryAI. Risultati di alta qualità.',
        keywords: 'Pika 2.2, animazione IA, WeryAI',
    },
    seedance: {
        title: 'Seedance - Generatore video danza e movimento IA | WeryAI',
        description: 'Prova Seedance su WeryAI. Risultati realistici e professionali.',
        keywords: 'Seedance, video IA, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Generatore Video AI da Regista | WeryAI',

        description: 'Crea video AI da regista con Werydance 2.0: riferimenti multimodali, coerenza narrativa e simulazione fisica. Gratis su WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, generatore video AI, video livello regista, video multimodale, simulazione fisica, sincronizzazione labiale, testo a video, video AI gratis, WeryAI',

        og_title: 'Werydance 2.0 - Generatore Video AI da Regista | WeryAI',

        og_description: 'Crea video AI da regista con Werydance 2.0: riferimenti multimodali, coerenza narrativa e simulazione fisica. Gratis su WeryAI.',

        twitter_title: 'Werydance 2.0 - Generatore Video AI da Regista | WeryAI',

        twitter_description: 'Crea video AI da regista con Werydance 2.0: riferimenti multimodali, coerenza narrativa e simulazione fisica. Gratis su WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - Generatore di Immagini IA | WeryAI',
        description: 'Usa Nano Banana Pro su WeryAI per immagini IA massima fedeltà! Rivaleggia con Midjourney in qualità. Crediti gratis, nessuna carta.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google immagine IA, immagine IA reasoning, 4K immagine IA, Nano Banana Pro gratis, come usare Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - Generatore di Immagini IA | WeryAI',
        description: 'Usa Nano Banana su WeryAI per creare immagini IA facilmente! Modello IA versatile e veloce per le tue esigenze creative. Crediti gratis, nessuna carta.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google immagine IA, generatore IA veloce, consistenza personaggi, Nano Banana gratis, come usare Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Prova il Generatore di Immagini IA | WeryAI',
        description: 'Usa FLUX su WeryAI per generare splendide immagini IA! Creato dal team di Stable Diffusion con qualità visiva eccezionale. Crediti gratis, nessuna carta.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, generatore di immagini IA, testo in immagine, arte IA, FLUX gratis, come usare FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Editor Immagini IA Pro | WeryAI',
        description: 'Usa FLUX Kontext su WeryAI per editing professionale di immagini IA! Aderenza superiore, tipografia avanzata e editing multi-step. Crediti gratis, nessuna carta.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, editor immagini IA, immagini IA pro, tipografia IA, FLUX Kontext gratis, come usare FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Generatore Immagini IA Google | WeryAI',
        description: 'Usa Google Imagen 4 su WeryAI per creare immagini IA fotorealistiche! Controllo stili versatile e generazione testo precisa. Crediti gratis, nessuna carta.',
        keywords: 'Imagen 4, Google Imagen, generatore immagini IA Google, testo in immagine, IA fotorealistica, Imagen gratis, come usare Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Modello Immagini IA Alibaba | WeryAI',
        description: 'Usa Qwen Image su WeryAI per generare arte IA multilingue! Modello open-source Alibaba con rendering testo superiore. Crediti gratis, nessuna carta.',
        keywords: 'Qwen Image, Alibaba AI, immagine IA open-source, rendering testo multilingue, Qwen Image gratis, come usare Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Generatore Immagini Alibaba | WeryAI',
        description: 'Usa Wan AI su WeryAI per immagini IA ad alta fedeltà! Modello Alibaba con preciso seguimento prompt e rendering fotorealistico. Crediti gratis, nessuna carta.',
        keywords: 'Wan AI, Wan 2.5, generatore immagini IA Alibaba, testo in immagine, IA fotorealistica, Wan AI gratis, come usare Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Immagine IA | WeryAI',
        description: 'Usa Seedream 4.0 su WeryAI per generazione ultra-rapida di immagini IA! Modello ByteDance con stili artistici diversificati. Crediti gratis, nessuna carta.',
        keywords: 'Seedream, Seedream 4.0, ByteDance immagine IA, immagine IA ultra-rapida, stili artistici IA, Seedream gratis, come usare Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - IA Immagine Multimodale | WeryAI',
        description: 'Usa Dreamina 4.0 su WeryAI per creazione multimodale di immagini IA! Schizzo in immagine, trasferimento stile e fusione personaggi. Crediti gratis, nessuna carta.',
        keywords: 'Dreamina 4.0, ByteDance immagine IA, immagine IA multimodale, schizzo in immagine, trasferimento stile, Dreamina gratis, come usare Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Immagine IA | WeryAI',
        description: 'Usa Seedream 4.5 su WeryAI per generazione immagini IA di punta! Ultimo ByteDance con tipografia precisa e fusione multi-immagine. Crediti gratis, nessuna carta.',
        keywords: 'Seedream 4.5, ByteDance immagine IA, modello di punta, rendering tipografico, fusione multi-immagine, Seedream 4.5 gratis, come usare Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Modello Definitivo di Generazione | WeryAI',
        description: 'Seedream 5.0 è il capolavoro di ByteDance nell\'IA visiva con qualità nativa 8K, comprensione semantica definitiva, composizione multi-soggetto e rendering testo 2.0. Provalo gratis su WeryAI.',
        keywords: 'Seedream 5.0, generazione immagini IA, qualità 8K, comprensione semantica, composizione multi-soggetto, rendering testo, ByteDance, WeryAI',
        og_title: 'Generatore di Immagini Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 è il capolavoro di ByteDance nella generazione visiva IA con qualità nativa 8K, comprensione semantica definitiva, composizione multi-soggetto e rendering del testo avanzato.',
        twitter_title: 'Generatore di Immagini Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 è il capolavoro di ByteDance nella generazione visiva IA con qualità nativa 8K, comprensione semantica definitiva, composizione multi-soggetto e rendering del testo avanzato.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Generatore di immagini AI Seedream 5.0',
        twitterImageAlt: 'Generatore di immagini AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Generatore Professionale di Grafica Vettoriale IA | WeryAI',
        description: 'Recraft V4 Vector è un generatore professionale di grafica vettoriale IA di Recraft.ai che genera vettori SVG modificabili con ridimensionamento senza perdite, tipografia precisa e controllo dello stile del marchio. Provalo gratis su WeryAI ora.',
        keywords: 'Recraft V4 Vector, generazione vettori IA, generatore SVG, vettore vero, design logo, icone UI, illustrazione vettoriale, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Generatore di Arte IA | WeryAI',
        description: 'Usa Midjourney su WeryAI per creare immagini IA artistiche! Famoso per estetica mozzafiato e qualità illuminazione. Crediti gratis, nessuna carta.',
        keywords: 'Midjourney, Midjourney AI, generatore arte IA, immagini IA artistiche, Midjourney gratis, alternativa Midjourney, come usare Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generatore Video IA | WeryAI',
        description: 'Crea video straordinari con Runway Gen-4.5 su WeryAI. Architettura ibrida autoregressiva-diffusione per simulazione fisica precisa e coerenza temporale.',
        keywords: 'Runway Gen-4.5, generatore video IA, video IA cinematografico, simulazione fisica, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generatore Video IA | WeryAI',
        description: 'Genera video di alta qualità con Kling 2.6 Pro su WeryAI. Generazione audiovisiva nativa, qualità cinematografica 1080p, eccellente aderenza ai prompt.',
        keywords: 'Kling 2.6 Pro, generatore video IA, video IA di alta qualità, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generatore Video Controllo camera | WeryAI',
        description: 'Genera video IA cinematografici con Dreamina 3.0 (Jimeng 3.0) su WeryAI. Controllo preciso frame inizio/fine, movimenti camera professionali e generazione video 1080p ad alta dinamica.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generatore video IA, controllo camera, frame inizio fine, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generatore Video IA Generazione Video | WeryAI',
        description: 'Libera la tua creatività su WeryAI con il generatore video IA Kling O1. Perfetto per generare contenuti video fantasiosi e unici.',
        keywords: 'Kling O1, generatore video IA, video IA creativo, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Generatore Video AI Intelligente | WeryAI',

        description: 'Crea video AI con Kling 3.0: storyboard intelligente, sincronizzazione labiale multilingue e rendering di testo preciso. Gratis su WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, generatore video AI, storyboard intelligente, sincronizzazione labiale, rendering testo, testo a video, immagine a video, video AI gratis, WeryAI',

        og_title: 'Kling 3.0 - Generatore Video AI Intelligente | WeryAI',

        og_description: 'Crea video AI con Kling 3.0: storyboard intelligente, sincronizzazione labiale multilingue e rendering di testo preciso. Gratis su WeryAI.',

        twitter_title: 'Kling 3.0 - Generatore Video AI Intelligente | WeryAI',

        twitter_description: 'Crea video AI con Kling 3.0: storyboard intelligente, sincronizzazione labiale multilingue e rendering di testo preciso. Gratis su WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Generatore Audio-Video AI Nativo 16s | WeryAI',

        description: 'Genera audio-video nativo di 16 secondi con Vidu Q3: montaggio intelligente, rendering testo preciso e lip-sync multilingue. Gratis su WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, generatore video AI, audio-video nativo 16s, storyboard intelligente, rendering testo, sincronizzazione labiale, testo a video, immagine a video, video AI gratis, WeryAI',

        og_title: 'Vidu Q3 - Generatore Audio-Video AI Nativo 16s | WeryAI',

        og_description: 'Genera audio-video nativo di 16 secondi con Vidu Q3: montaggio intelligente, rendering testo preciso e lip-sync multilingue. Gratis su WeryAI.',

        twitter_title: 'Vidu Q3 - Generatore Audio-Video AI Nativo 16s | WeryAI',

        twitter_description: 'Genera audio-video nativo di 16 secondi con Vidu Q3: montaggio intelligente, rendering testo preciso e lip-sync multilingue. Gratis su WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - Generatore Immagini OpenAI | WeryAI',
        description: 'Usa GPT-4o su WeryAI per creare immagini tramite conversazione! IA OpenAI con rendering testo preciso e risultati alta fedeltà. Crediti gratis, nessuna carta.',
        keywords: 'GPT-4o, GPT-4o immagine, generatore immagini OpenAI, arte IA conversazionale, GPT-4o gratis, come usare GPT-4o immagini, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - Generatore Arte OpenAI | WeryAI',
        description: 'Usa GPT Image 1.5 su WeryAI per arte IA di nuova generazione! Ultimo modello OpenAI con creatività e dettagli migliorati. Crediti gratis, nessuna carta.',
        keywords: 'GPT Image 1.5, modello immagine OpenAI, generatore arte IA, IA nuova generazione, GPT Image 1.5 gratis, come usare GPT Image 1.5, WeryAI',
    },
    heygen_ai: {
        title: 'HeyGen AI Generatore Video - Piattaforma Presentatore Virtuale AI | WeryAI',
        description: 'Prova il generatore video HeyGen AI specializzato in video con presentatore virtuale e doppiaggio multilingue. Crea contenuti video professionali con avatar AI realistici e voce naturale. Prova gratis su WeryAI.',
        keywords: 'HeyGen AI, generatore video AI, presentatore virtuale, doppiaggio AI, produzione video, video AI gratis, WeryAI',
        og_title: 'HeyGen AI Generatore Video - Piattaforma Presentatore Virtuale AI | WeryAI',
        og_description: 'Crea video professionali con presentatore virtuale usando HeyGen AI. Avatar AI realistici, doppiaggio multilingue e voce naturale. Prova gratis su WeryAI.',
        twitter_title: 'HeyGen AI Generatore Video - Piattaforma Presentatore Virtuale AI | WeryAI',
        twitter_description: 'Crea video professionali con presentatore virtuale usando HeyGen AI. Avatar AI realistici, doppiaggio multilingue e voce naturale. Prova gratis su WeryAI.',
    },
    higgsfield_ai: {
        title: 'Higgsfield AI Generatore Video - Controllo Cinematografico Telecamera | WeryAI',
        description: 'Prova il generatore video Higgsfield AI specializzato in controllo cinematografico della telecamera e storytelling visivo. Crea contenuti video AI di qualità da regista con direzione telecamera precisa. Prova gratis su WeryAI.',
        keywords: 'Higgsfield AI, generatore video AI, video cinematografico, controllo telecamera, produzione video, video AI gratis, WeryAI',
        og_title: 'Higgsfield AI Generatore Video - Controllo Cinematografico Telecamera | WeryAI',
        og_description: 'Genera video AI cinematografici con Higgsfield AI. Controllo telecamera preciso, storytelling visivo e output di qualità da regista. Prova gratis su WeryAI.',
        twitter_title: 'Higgsfield AI Generatore Video - Controllo Cinematografico Telecamera | WeryAI',
        twitter_description: 'Genera video AI cinematografici con Higgsfield AI. Controllo telecamera preciso, storytelling visivo e output di qualità da regista. Prova gratis su WeryAI.',
    },
    invideo_ai: {
        title: 'InVideo AI Generatore Video - Piattaforma Editing Video Intelligente | WeryAI',
        description: 'Prova il generatore video InVideo AI specializzato in editing video intelligente e creazione automatizzata di contenuti. Crea video di livello professionale con istruzioni in linguaggio naturale. Prova gratis su WeryAI.',
        keywords: 'InVideo AI, generatore video AI, editing video intelligente, creazione automatizzata, produzione video, video AI gratis, WeryAI',
        og_title: 'InVideo AI Generatore Video - Editing Video Intelligente | WeryAI',
        og_description: 'Crea video professionali con InVideo AI usando istruzioni in linguaggio naturale. Editing intelligente e creazione automatizzata di contenuti. Prova gratis su WeryAI.',
        twitter_title: 'InVideo AI Generatore Video - Editing Video Intelligente | WeryAI',
        twitter_description: 'Crea video professionali con InVideo AI usando istruzioni in linguaggio naturale. Editing intelligente e creazione automatizzata di contenuti. Prova gratis su WeryAI.',
    },
    luma_dream_machine: {
        title: 'Luma Dream Machine Generatore Video - Creazione Video AI Onirico | WeryAI',
        description: 'Prova il generatore video Luma Dream Machine specializzato in effetti visivi onirici e generazione video creativa. Crea contenuti video surreali e immaginativi con potente tecnologia AI. Prova gratis su WeryAI.',
        keywords: 'Luma Dream Machine, generatore video AI, video onirico, video creativo, produzione video, video AI gratis, WeryAI',
        og_title: 'Luma Dream Machine Generatore Video - Video AI Onirico | WeryAI',
        og_description: 'Crea video AI surreali e onirici con Luma Dream Machine. Potenti effetti visivi e generazione di contenuti immaginativi. Prova gratis su WeryAI.',
        twitter_title: 'Luma Dream Machine Generatore Video - Video AI Onirico | WeryAI',
        twitter_description: 'Crea video AI surreali e onirici con Luma Dream Machine. Potenti effetti visivi e generazione di contenuti immaginativi. Prova gratis su WeryAI.',
    },
    leonardo_ai: {
        title: 'Leonardo AI Generatore Immagini - Art Direction a Sistema Visivo | WeryAI',
        description: 'Prova il generatore di immagini Leonardo AI, trasforma l\'art direction in un sistema visivo raffinato, crea linguaggio visivo coerente per personaggi, prodotti e campagne. Prova gratis su WeryAI.',
        keywords: 'Leonardo AI, generatore immagini AI, concept art, character design, creazione immagini, immagine AI gratis, WeryAI',
        og_title: 'Leonardo AI Generatore Immagini - Art Direction a Sistema Visivo | WeryAI',
        og_description: 'Trasforma l\'art direction in un sistema visivo raffinato con Leonardo AI. Character design coerente, concept art e visual di campagne. Prova gratis su WeryAI.',
        twitter_title: 'Leonardo AI Generatore Immagini - Art Direction a Sistema Visivo | WeryAI',
        twitter_description: 'Trasforma l\'art direction in un sistema visivo raffinato con Leonardo AI. Character design coerente, concept art e visual di campagne. Prova gratis su WeryAI.',
    },
    soulgen_ai: {
        title: 'SoulGen AI Generatore Immagini - Concept Personaggio con Prospettiva Distinta | WeryAI',
        description: 'Prova il generatore di immagini SoulGen AI, dai ai concept dei personaggi un punto di vista distinto. Crea immagini espressive da note sui personaggi, riferimenti visivi e mood. Prova gratis su WeryAI.',
        keywords: 'SoulGen AI, generatore personaggi AI, character design, creazione immagini, immagine AI gratis, WeryAI',
        og_title: 'SoulGen AI Generatore Immagini - Creazione Concept Personaggio | WeryAI',
        og_description: 'Dai ai concept dei personaggi una voce visiva distinta con SoulGen AI. Crea immagini espressive da personalità, riferimenti e mood. Prova gratis su WeryAI.',
        twitter_title: 'SoulGen AI Generatore Immagini - Creazione Concept Personaggio | WeryAI',
        twitter_description: 'Dai ai concept dei personaggi una voce visiva distinta con SoulGen AI. Crea immagini espressive da personalità, riferimenti e mood. Prova gratis su WeryAI.',
    },
    stable_diffusion: {
        title: 'Stable Diffusion Generatore Immagini - Arte AI Open Source | WeryAI',
        description: 'Prova il generatore di immagini Stable Diffusion, uno strumento di generazione immagini AI open-source e potente. Crea opere d\'arte AI uniche con controllo flessibile e stili diversi. Prova gratis su WeryAI.',
        keywords: 'Stable Diffusion, generatore immagini AI, AI open source, generazione immagini, arte AI, immagini AI gratis, WeryAI',
        og_title: 'Stable Diffusion Generatore Immagini - Arte AI Open Source | WeryAI',
        og_description: 'Crea opere d\'arte AI uniche con controlli flessibili e stili diversi di Stable Diffusion. Open-source e potente. Prova gratis su WeryAI.',
        twitter_title: 'Stable Diffusion Generatore Immagini - Arte AI Open Source | WeryAI',
        twitter_description: 'Crea opere d\'arte AI uniche con controlli flessibili e stili diversi di Stable Diffusion. Open-source e potente. Prova gratis su WeryAI.',
    },
}
